import gql from "graphql-tag"

export const ProductFields = gql`
  fragment ProductFields on ProductRecord {
    id
    slug
    updatedAt
    productName
    module
    productCategory {
      name
      slug
    }
    productSubcategory {
      name
      slug
    }
    productLine {
      name
      slug
    }
    productSize {
      size
    }
    productStyle {
      id
      name
      slug
      icon {
        responsiveImage {
          srcSet
          webpSrcSet
          sizes
          src
          width
          height
          aspectRatio
          alt
          title
          bgColor
          base64
        }
      }
    }
    proSeriesCategory {
      name
      slug
    }
    proSeriesSubcategory {
      id
      name
      slug
      icon {
        responsiveImage {
          srcSet
          webpSrcSet
          sizes
          src
          width
          height
          aspectRatio
          alt
          title
          bgColor
          base64
        }
      }
    }
    make {
      name
      slug
    }
    model {
      name
      slug
    }
    trim {
      name
      slug
    }
    year
    tags
    multipleApplication
    advancedCompatibility {
      ... on CompatibleWithRecord {
        __typename
        make {
          slug
        }
        model {
          slug
        }
        year
        trim {
          slug
        }
      }
      ... on NotCompatibleWithRecord {
        __typename
        make {
          slug
        }
        model {
          slug
        }
        year
        trim {
          slug
        }
      }
    }
    price
    compareAtPrice
    discountedPrice
    isDiscounted
    soldAs
    thumbnail {
      responsiveImage {
        src
      }
    }
    materials {
      name
    }
    colorTones {
      name
      color {
        hex
      }
    }
    swatchVehicleCompatibility {
      name
    }
  }
`

export const productChildrenQuery = gql`
  query ($id: ItemId) {
    allProducts(first: "100", filter: { parentProduct: { eq: $id } }) {
      id
      slug
      updatedAt
      productName
      price
      discountedPrice
      isDiscounted
      compareAtPrice
      soldAs
      thumbnail {
        responsiveImage {
          src
        }
      }
    }
  }
`
